/*
*###############################################################################
*Module Name                   : StockFreezeContent.js                         #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               :  T A C Priyashad                              #
*Date                          : Wednesday, March 1st 2022, 7:50:28 am         #
*Copyright (c) 2022 myPOS Software Solution (pvt Ltd.)                         #
*###############################################################################
*/

import React, { useState, useEffect } from 'react'
import { CardText, Col, Row, Alert, Button, Modal, Table, Label } from 'reactstrap'
import DPTextBox from 'framework/components/DPTextBox'
import DPSwitch from 'framework/components/DPSwitch'
import DPSearchBox from 'framework/components/DPSearchBox'
import DPTextBoxButton from 'framework/components/DPTextBoxButton'
import imageExcelUpload from "../../../assets/images/Upload.png"
import imageExcelDownload from "../../../assets/images/Download.png"
import MasterUpload from "../../../assets/File/StockFreezeUpload.xlsx";
import DPSearchBoxDynamic from 'framework/components/DPSearchBoxDynamic'
import DPSearchBoxSingleDynamic from 'framework/components/DPSearchBoxSingleDynamic'
import { GetSearchTable } from './StockFreezeController'
import DPTextBoxforgrid from 'framework/components/DPTextBoxforgrid'
import DPDropDown from 'framework/components/DPDropDown'

const StockFreezeContent = ({
    Gen_strLocation,
    Gen_blLocationEnable,
    Gen_IsLocation,
    Gen_Location_OnChange,
    Gen_Location_Blur,
    SwLocationonChange,
    SearchModelOpenLoc,
    SearchModelTriggerLoc,
    SearchGetSelectRowLoc,
    Gen_strVendor,
    Gen_blVendorEnable,
    Gen_IsVendor,
    Gen_Vendor_OnChange,
    Gen_Vendor_Blur,
    SwVendoronChange,
    SearchModelOpenVen,
    SearchModelTriggerVen,
    SearchGetSelectRowVen,
    DescValue,
    DescOnChange,
    disabled,
    show,
    AlertMsg,
    AlertColor,
    modelOpen,
    modelTrigger,
    GetSelectRow,
    disabledCode,
    ErrorMsg,
    menuName,
    SearchDisable,
    showFileUpload,
    valueUpload,
    menuCode,
    loadItems,
    strLocationDesc,
    strVendorDesc,
    txnTypes,
    selectedTxn,
    handleTxnChange,
    GrpData,
    allLocations,
    remarks,
    remarksOnChange
}) => {

    const ApiURL = window.Links.ApiURL

    const [DataTablesLoc, SetDatatableLoc] = useState([])
    const [groupFilterLoc, SetGroupFilterLoc] = useState('a')
    const [columnsLoc, setColumnsLoc] = useState([])

    const [DataTablesVen, SetDatatableVen] = useState([])
    const [groupFilter, SetGroupFilter] = useState('a')
    const [columnsSupp, setColumnsSupp] = useState([])

    //*** End of useStates */


    const defaultSortedSup = [
        {
            dataField: "id",
            order: "asc",
        },
    ]

    const defaultSortedLoc = [
        {
            dataField: "id",
            order: "asc",
        },
    ]

    return (
        <React.Fragment>
            <div>
                <Col sm="12">
                    <CardText className="mb-0">
                        <Row>
                            {show ? (
                                <Alert color={AlertColor} role="alert">
                                    {AlertMsg}
                                    <br />
                                    <small>{ErrorMsg}</small>
                                </Alert>
                            ) : null}
                            <Col sm={12} md={10} className="mb-4-sm">
                                <Row>
                                    <Col sm={12} md={1} className="mb-4-sm">
                                        <Label
                                            htmlFor="example-text-input"
                                            className={`col-md-12 col-form-label-sm`}
                                        >
                                            Location
                                        </Label>
                                    </Col>
                                    <Col sm={12} md={6} className="mb-4-sm">
                                        <DPDropDown
                                            rowClass="mb-4-sm"
                                            labelHide={true}
                                            selectedGroup={Gen_strLocation}
                                            onChange={Gen_Location_OnChange}
                                            disabled={Gen_blLocationEnable}
                                            optionGroup={allLocations}
                                        />
                                    </Col>

                                </Row>
                                <Row>
                                    <Col sm={12} md={1} className="mb-4-sm">
                                        <Label
                                            htmlFor="example-text-input"
                                            className={`col-md-12 col-form-label-sm`}
                                        >
                                            Supplier
                                        </Label>
                                    </Col>
                                    <Col sm={12} md={3} className="mb-4-sm">
                                        <DPTextBoxforgrid
                                            rowClass="mb-4-sm"
                                            textType="text"
                                            LableClass="col-md-4 col-form-label-sm"
                                            TextBoxClass="col-md-8"
                                            value={Gen_strVendor}
                                            onChange={Gen_Vendor_OnChange}
                                            disabled={Gen_blVendorEnable ? true : GrpData.length > 0 ? true : false}
                                            onBlur={Gen_Vendor_Blur}
                                        />
                                    </Col>
                                    <Col sm={12} md={3} className="mb-4-sm">
                                        <DPTextBoxforgrid
                                            rowClass="mb-4-sm"
                                            textType="text"
                                            LableClass="col-md-4 col-form-label-sm"
                                            TextBoxClass="col-md-8"
                                            value={strVendorDesc}
                                            disabled={true}
                                        />
                                    </Col>
                                    <Col sm={12} md={1} className="mb-4-sm">
                                        <Button
                                            color="success"
                                            className="btn-sm"
                                            disabled={Gen_blVendorEnable ? true : GrpData.length > 0 ? true : false}
                                            onClick={SearchModelTriggerVen}
                                        >
                                            <i
                                                className="mdi mdi-search-web"
                                                style={{ fontSize: "12px" }}
                                            ></i>
                                        </Button>
                                    </Col>
                                </Row>
                                <Row>

                                </Row>
                                <Row>
                                    <Col sm={12} md={1} className="mb-4-sm">
                                        <Label
                                            htmlFor="example-text-input"
                                            className={`col-md-12 col-form-label-sm`}
                                        >
                                            Txn Types
                                        </Label>
                                    </Col>
                                    <Col sm={12} md={6} className="mb-4-sm">
                                        <DPDropDown
                                            rowClass="mb-4-sm"
                                            labelHide={true}
                                            selectedGroup={selectedTxn}
                                            onChange={handleTxnChange}
                                            disabled={disabled}
                                            optionGroup={txnTypes}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={12} md={1} className="mb-4-sm">
                                        <Label
                                            htmlFor="example-text-input"
                                            className={`col-md-12 col-form-label-sm`}
                                        >
                                            Remarks
                                        </Label>
                                    </Col>
                                    <Col sm={12} md={6} className="mb-4-sm">
                                        <DPTextBoxforgrid
                                            value={remarks}
                                            onChange={remarksOnChange}
                                            textType="text"
                                            maxLength="200"
                                        />
                                    </Col>
                                </Row>
                                {/* <Row>
                                    <Col sm={12} md={2} className="mb-4-sm">
                                        <Button
                                            onClick={() => {
                                                loadItems()
                                            }}
                                            color="success"
                                            className="btn-sm"
                                            disabled={SearchDisable}
                                        >
                                            Load Products
                                        </Button>
                                    </Col>
                                </Row> */}
                            </Col>
                            <Col sm={12} md={2} className="mb-4-sm">
                                <ul className="import-export-button-block" style={{ display: "flex", flexFlow: "row", flexWrap: "wrap", padding: "0px", justifyContent: "end" }}>
                                    <li className="import-export-button" style={{ display: "block" }}>
                                        <input
                                            id="file"
                                            type="file"
                                            onChange={showFileUpload}
                                            value={valueUpload}
                                            disabled={disabledCode}
                                            accept=".xlsx, .xls, .csv"
                                            style={{ display: "none" }}
                                        />

                                        <label htmlFor="file" title="Stock Freeze Excel Upload" style={{ cursor: "pointer", opacity: disabledCode == true ? "0.5" : "1" }}>
                                            <span >
                                                <img class="manImg" src={imageExcelUpload} style={{ width: "40px", height: "40px" }}></img>
                                            </span>
                                        </label></li>

                                    <li className="import-export-button" style={{ display: "block" }}>
                                        <a href={MasterUpload} download="Stock Freeze Upload" data-tip title="Stock Freeze excel format download"
                                            style={{ pointerEvents: disabledCode ? 'none' : '', }} >
                                            <img class="manImg" src={imageExcelDownload} style={{ width: "40px", height: "40px", opacity: disabledCode == true ? "0.5" : "1" }}></img>
                                        </a></li>
                                </ul>
                            </Col>
                        </Row>
                        <DPSearchBoxDynamic
                            searchData={DataTablesLoc}
                            columns={columnsLoc}
                            defaultSorted={defaultSortedLoc}
                            mainTitle={"Location Search"}
                            SelectType={"checkbox"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                            isOpen={SearchModelOpenLoc}
                            toggle={SearchModelTriggerLoc}
                            getSelect={SearchGetSelectRowLoc}
                            APIURL={ApiURL}
                            URLPath={"LOCATION"}
                            MenuCode={menuCode}
                            KeyVal={'TXN'}
                            searchBy={'LOC_CODE'}
                            FilterStr={groupFilterLoc}
                        />
                        <DPSearchBoxDynamic
                            searchData={DataTablesVen}
                            columns={columnsSupp}
                            defaultSorted={defaultSortedSup}
                            mainTitle={"Supplier Search"}
                            SelectType={"checkbox"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                            isOpen={SearchModelOpenVen}
                            toggle={SearchModelTriggerVen}
                            getSelect={SearchGetSelectRowVen}
                            APIURL={ApiURL}
                            URLPath={"SUPPLIER"}
                            MenuCode={menuCode}
                            KeyVal={'TXN'}
                            searchBy={'SM_CODE'}
                            FilterStr={groupFilter}
                        />
                    </CardText>
                </Col>
            </div>
        </React.Fragment >
    )

}

export default StockFreezeContent